import type {
  AdminJobApplication,
  AdminJobApplicationResponse,
  JobApplicationCounts,
  JobApplicationCountsResponse,
  JobApplicationList,
  JobApplicationListQuery,
  JobApplicationStatus,
} from '@mds/shared/types/job-application';

import { api } from '@/lib/api';

export const listApplications = (
  query: JobApplicationListQuery = {},
): Promise<JobApplicationList> =>
  api.get<JobApplicationList>('admin/applications', { query: { ...query } });

export const getApplicationCounts = (): Promise<JobApplicationCounts> =>
  api
    .get<JobApplicationCountsResponse>('admin/applications/counts')
    .then((response) => response.data);

export const getApplication = (id: string): Promise<AdminJobApplication> =>
  api
    .get<AdminJobApplicationResponse>(`admin/applications/${id}`)
    .then((response) => response.data);

export const setApplicationStatus = (
  id: string,
  status: JobApplicationStatus,
  note?: string,
): Promise<AdminJobApplication> =>
  api
    .post<AdminJobApplicationResponse>(`admin/applications/${id}/status`, {
      status,
      ...(note?.trim() ? { note: note.trim() } : {}),
    })
    .then((response) => response.data);

export const addApplicationNote = (id: string, body: string): Promise<AdminJobApplication> =>
  api
    .post<AdminJobApplicationResponse>(`admin/applications/${id}/notes`, {
      body: body.trim(),
    })
    .then((response) => response.data);
